import { MAXIMUM_MW_PER_PTU } from '@/features/bidding/constants'

export const isCapacityValid = (value: string): boolean => {
  // An integer or a float number with up to two decimals
  const isValidNumber = /^\d+\.?\d{0,2}$/.test(value)

  return isValidNumber && Number(value) >= 0 && Number(value) <= MAXIMUM_MW_PER_PTU
}
